import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: '',
    children: [
      {
        path: 'soar-ia',
        loadComponent: () => import('./soar-ia.component').then((m) => m.SoarIaComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class soarIaRoutingModule {
  static routes = admin;
}
